import axiosInstance from '../auth/axiosInstance';

const unwrapResponseData = (result: unknown) => {
  if (!result || typeof result !== 'object') return null;
  const root = result as Record<string, unknown>;
  return root.data ?? result;
};

/**
 * Load the most recent saved value estimation for a project.
 * Target table: BusinessValueCalculators (GET by project).
 */
export const getBusinessValueCalculationByProject = async (projectId: number) => {
  try {
    const { data: result } = await axiosInstance.get(
      `/CostEstimation/GetBusinessValueCalculationByProject/${projectId}`
    );
    return unwrapResponseData(result);
  } catch (error) {
    console.error('Error fetching value estimation by project:', error);
    throw error;
  }
};

/**
 * Future submit target — not wired on the form yet.
 * POST /CostEstimation/AddOrUpdateBusinessValueCalculation
 */
export const addOrUpdateBusinessValueCalculation = async (payload: Record<string, unknown>) => {
  const { data: result } = await axiosInstance.post(
    '/CostEstimation/AddOrUpdateBusinessValueCalculation',
    payload
  );
  return unwrapResponseData(result);
};
